import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"padding-top":"1rem"} }
const _hoisted_3 = {
  key: 0,
  class: "submitcontent"
}

import { onMounted, ref,computed,watch} from "vue";
import {showToast,showLoadingToast} from 'vant'
import TimePicker from "@/components/TimePicker/TimePicker.vue";
import ZCell from "@/components/ZCell/ZCell.vue";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import employeeApi from "@/utils/Api/Employee"
import {useRoute} from "vue-router";
import dic from "@/assets/ts/dictionary";
import router from "@/router";
import merchantEmployeeApi from "@/utils/Api/MerchantEmployee";


export default /*@__PURE__*/_defineComponent({
  __name: 'personapplydetail',
  setup(__props) {

const route=useRoute();


onMounted(() => {
  document.title = route.query.look?'查看个人入协申请':(route.query.id?'编辑个人入协申请':'新增个人入协申请');
  if(route.query.id){
    getDetail();
  }
})

const form = ref({
  companyid: "",
  username: "",
  telephone: "",
  industrytime: "",
  loginaccount: "",
  loginpassword: "",
  userimg: [],
  userdesc: "",
  isShow:false,
  "auditStatus": 0
})
let loading='';

const getDetail=()=>{
  loading=showLoadingToast({
    forbidClick: true,
  });
  merchantEmployeeApi.detail(route.query.id).then(res=>{
    form.value=res.data;
    let userimg=[];
    userimg.push(res.data.userimg)
    form.value.userimg=userimg;
    if(!form.value.industrytime){
      form.value.industrytime='';
    }
  }).finally(()=>{
    loading.close();
  })
}

//提交
const onSubmit = (values: any) => {
  console.log('submit1', values);
  loading=showLoadingToast({
    forbidClick: true,
  });
  if(form.value.userimg.length==0){
    showToast({
      message:'请上传照片',
    });
    return;
  }
  console.log(form.value)
  merchantEmployeeApi.updateOrAdd(route.query.id?1:0, {
    ...form.value,
    userimg:form.value.userimg?.[0]
    }).then(()=>{
      showToast({
        message:route.query.id?'编辑成功':'新增成功',
        onClose:()=>{
          router.push('/accountapply')
        }
      });
    }).finally(()=>{
      loading.close();
    })

}
const show = ref(false);
const customFieldName = {
  text: 'label'
};
const onConfirmMerchant = ({selectedOptions}) => {
  show.value = false;
  console.log(selectedOptions)
  form.value.merchantCategoryName = selectedOptions[0].label;
  form.value.merchantCategory= selectedOptions[0].value;
}
const getImgList=(formName:any,data:any)=>{
  console.log(formName,data)
  form.value[formName]=data;
}


return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: _unref(route).query.look?'查看个人入协申请':(_unref(route).query.id?'编辑个人入协申请':'新增个人入协申请'),
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, {
      onSubmit: onSubmit,
      disabled: _unref(route).query.look,
      "show-error": "",
      "show-error-message": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ZCell, {
            label: "姓名",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.username,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.username) = $event)),
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写会员名称' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "服务电话",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.telephone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.telephone) = $event)),
                type: "tel",
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写服务电话' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "入行时间",
            modelValue: form.value.industrytime,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.industrytime) = $event)),
            disabled: _unref(route).query.look
          }, {
            default: _withCtx(() => [
              _createVNode(TimePicker, {
                modelValue: form.value.industrytime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.industrytime) = $event)),
                readonly: _unref(route).query.look,
                rules: [{ required: true, message: '请填写' }]
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]),
          _createVNode(ZCell, {
            label: "登录账号",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.loginaccount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.loginaccount) = $event)),
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写登录账号' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "登录密码",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.loginpassword,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.loginpassword) = $event)),
                type: "password",
                placeholder: _unref(route).query.look?'':'请输入',
                rules: [{ required: true, message: '请填写登录账号' }]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "人员照片",
            hiddenArrow: "",
            require: "",
            style: {"align-items":"flex-start!important"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(UploadImage, {
                  count: 1,
                  disabled: _unref(route).query.look,
                  list: form.value.userimg,
                  "aspect-ratio": 4/5,
                  onGetImgList: _cache[7] || (_cache[7] = e=>getImgList('userimg',e))
                }, null, 8, ["disabled", "list"])
              ])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "是否公示",
            hiddenArrow: "",
            require: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_radio_group, {
                disabled: _unref(route).query.look,
                class: "van-cell",
                modelValue: form.value.isShow,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.isShow) = $event)),
                direction: "horizontal",
                rules: [{ required: true, message: '是否公示' }]
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dic).getDicList('publicStatus'), (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_radio, {
                      name: item.value,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(ZCell, {
            label: "个人简介",
            hiddenArrow: "",
            style: {"align-items":"flex-start!important"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: form.value.userdesc,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.userdesc) = $event)),
                rows: "6",
                autosize: "",
                type: "textarea",
                placeholder: _unref(route).query.look?'':'请输入'
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"height":"12.5rem"} }, null, -1)),
          (!_unref(route).query.look)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_van_button, {
                  round: "",
                  block: "",
                  class: "primary-btn",
                  type: "primary",
                  "native-type": "submit"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode(" 提交 ")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})